import $ from 'jquery';

function mainNavCollapse() {
  const root = document.documentElement;
  const mainNav = $('#navbar-collapse');

  // have to use jQuery as the events aren't "normal" JS events
  mainNav.on('hidden.bs.collapse shown.bs.collapse', event => {
    root.dataset.mainNav = event.type;
  });
}

export { mainNavCollapse };
